var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListInvalid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.342849 1.75755C-0.0476753 1.36703 -0.0476752 0.733862 0.342849 0.343338C0.733373 -0.0471866 1.36654 -0.0471866 1.75706 0.343338L11.6566 10.2428C12.0471 10.6334 12.0471 11.2665 11.6566 11.657C11.266 12.0476 10.6329 12.0476 10.2423 11.657L0.342849 1.75755Z",
    fill: "#F23232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75706 11.657C1.36654 12.0476 0.733373 12.0476 0.342849 11.657C-0.0476753 11.2665 -0.0476754 10.6334 0.342849 10.2428L10.2423 0.343337C10.6329 -0.047187 11.266 -0.0471872 11.6566 0.343337C12.0471 0.733861 12.0471 1.36703 11.6566 1.75755L1.75706 11.657Z",
    fill: "#F23232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListInvalid);
export default __webpack_public_path__ + "static/media/list-invalid.467d196c8a49d08ed03ddbf356e7967f.svg";
export { ForwardRef as ReactComponent };